import React from 'react';

// Inicio Mobile. Base del futuro inicio operativo ("¿hay algo que RH necesite
// saber o hacer ahora?"). Por ahora sólo saludo, fecha e identidad: sin
// accesos a módulos (eso es la barra inferior), sin KPIs ni datos ficticios.

function saludoPorHora(hora) {
  if (hora < 12) return 'Buenos días';
  if (hora < 19) return 'Buenas tardes';
  return 'Buenas noches';
}

export function primerNombre(usuario) {
  const nombre = (usuario.name || '').trim().split(/\s+/)[0];
  return nombre || (usuario.email || '').split('@')[0];
}

export function InicioMobile({ usuario, emblema }) {
  const ahora = new Date();
  const fecha = ahora.toLocaleDateString('es-MX', { weekday: 'long', day: 'numeric', month: 'long' });

  return (
    <section className="m-bienvenida" aria-labelledby="m-saludo">
      <img className="m-bienvenida-marca" src={emblema} alt="" aria-hidden="true" />
      <p className="m-fecha">{fecha}</p>
      <h1 id="m-saludo" className="m-saludo">{saludoPorHora(ahora.getHours())}, {primerNombre(usuario)}</h1>
      <p className="m-bienvenida-sub">Sistema Integral de Recursos Humanos</p>
    </section>
  );
}
